import React from "react";
import { Box, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useDispatch, useSelector } from "react-redux";
import { setDateRange, tableSelector } from "../../store/slices/tableSlice";
import moment from "moment";

const DateFilter = () => {
  const dispatch = useDispatch();
  const { startDate, endDate } = useSelector(tableSelector);

  const handleStartDateChange = (newValue) => {
    dispatch(
      setDateRange({
        startDate: newValue ? newValue.format("YYYY-MM-DD") : null,
        endDate: endDate,
      })
    );
  };

  const handleEndDateChange = (newValue) => {
    dispatch(
      setDateRange({
        startDate: startDate,
        endDate: newValue ? newValue.format("YYYY-MM-DD") : null,
      })
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Box sx={{ p: 2 }}>
        <Stack direction="row" spacing={2}>
          <DatePicker
            label="Start Date"
            value={startDate ? moment(startDate) : null}
            onChange={handleStartDateChange}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
              },
            }}
          />
          <DatePicker
            label="End Date"
            value={endDate ? moment(endDate) : null}
            onChange={handleEndDateChange}
            minDate={startDate ? moment(startDate) : null}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
              },
            }}
          />
        </Stack>
      </Box>
    </LocalizationProvider>
  );
};

export default DateFilter;
